import type { SugarmateError } from "@tandemdiabetes/sugarmate-api-react-client"
import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  status?: SugarmateError["status"];
}

const polyglotPrefix = "toasts.validate_email_confirmation_code_error."

export function ValidateEmailConfirmationCodeErrorToast(props: Props) {
  const {
    id,
    status: responseStatus,
  } = props

  const polyglot = usePolyglot()
  const body = useMemo(
    () => {
      if (responseStatus === 429) {
        return polyglot.t(`${polyglotPrefix}rate_limited_body`)
      }

      return polyglot.t("error_messaging.generic_error")
    },
    [
      responseStatus,
      polyglot,
    ],
  )

  return (
    <Toast
      stylePreset="error"
      body={body}
      id={id}
    />
  )
}
